import { httpV1 as http } from '../api';

export async function completeSurvey(data) {
  return http
    .patch('/survey/0', data)
    .then(({ data }) => data);
}
